export const domEventTypes = {
    click: 'click',
    keypress: 'click'
};
export const instrumentTypes = {
    DOM: 'DOM',
    FORM: 'FORM',
    REDUX: 'REDUX',
    CONSOLE: 'CONSOLE',
    APM_TRANSACTION: 'APM_TRANSACTION',
    XHR: 'XHR',
    FETCH: 'FETCH'
};
export const GENERIC_REACT_WARNINGS = [
    'getDerivedStateFromProps()',
    'React does not recognize',
    'validateDOMNesting(...)',
    "Can't perform a React state update",
    'Failed prop type',
    'Unknown prop',
    'Each child in a list'
];
export const TRACEPARENT_HEADER = 'traceparent';
